import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const spacingTypes = ['margin', 'padding'];
const spacingSizes = ['0', 'xxs', 'xs', 's', 'm', 'l', 'xl'];
const spacingPositions = {
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  topBottom: 'TopBottom',
  leftRight: 'LeftRight',
  none: '',
};

export default function Spacing({
  children,
  type,
  position,
  size,
  sizeS,
  sizeM,
  sizeL,
}) {
  const spacingPosition = position ? spacingPositions[position] : '';
  const spacingClass = cx(`${type}${spacingPosition}-${size}`, {
    [`breakPointS-${type}${spacingPosition}-${sizeS}`]: sizeS,
    [`breakPointM-${type}${spacingPosition}-${sizeM}`]: sizeM,
    [`breakPointL-${type}${spacingPosition}-${sizeL}`]: sizeL,
  });

  return <div className={spacingClass}>{children}</div>;
}

Spacing.propTypes = {
  children: PropTypes.node.isRequired,
  position: PropTypes.oneOf(spacingPositions),
  size: PropTypes.oneOf(spacingSizes),
  sizeL: PropTypes.oneOf(spacingSizes),
  sizeM: PropTypes.oneOf(spacingSizes),
  sizeS: PropTypes.oneOf(spacingSizes),
  type: PropTypes.oneOf(spacingTypes),
};

Spacing.defaultProps = {
  position: 'none',
  type: 'margin',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-spacing/Spacing/index.js